<template>
  <div>
    <div :class="this.isMobile.value ? 'resume-editor-mobile' : 'resume-editor'" ref="editorFrom">
      <div class="profile-header">
        <div class="profile-header__title">
          <h1 style="display: inline;">新增答疑/投诉</h1>
        </div>
      </div>
      <br/>
      <div>
        <div class="register-wrapper">
          <el-form :rules="rulesReport" ref="formReport" label-width="60px" :model="formReport">
            <el-form-item label="类型" prop="typeId">
              <el-select v-model="formReport.typeId" placeholder="请选择" disabled>
                <el-option
                  v-for="dict in typeIdOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="parseInt(dict.dictValue)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提问内容" prop="askContent">
              <el-input type="textarea" v-model="formReport.askContent" :autosize="{ minRows: 3, maxRows: 50}"/>
            </el-form-item>
            <el-form-item label="提问附件" prop="applyFileList">
              <el-upload
                ref="fileUpload"
                :limit="10"
                accept="doc,docx,xls,xlsx,ppt,zip,rar,pdf"
                multiple
                :on-exceed="fileLimitCallback"
                :action="upload.url"
                :headers="upload.headers"
                :file-list="applyFileList"
                :on-progress="handleFileUploadProgress"
                :before-upload="onBeforeUpload"
                :on-change="handleFileChange"
                :on-success="
                  (response, file, fileList) =>
                    uploadFileSuccess(response, file, fileList)
                "
                :on-error="handleFileError"
                :on-preview="handlePreview"
                :on-remove="
                  (file, fileList) => removeFileSuccess(file, fileList)
                "
                :auto-upload="false"
                :disabled="disabled"
              >
                <el-button slot="trigger" size="small" type="primary" v-if="!disabled"
                >选取文件</el-button
                >
                <el-button
                  style="margin-left: 10px"
                  size="small"
                  type="success"
                  :loading="upload.isUploading"
                  @click="submitUpload()"
                  v-if="!disabled"
                >上传</el-button
                >
                <div slot="tip" class="el-upload__tip" v-if="!disabled">文件不超过200M</div>
              </el-upload>
            </el-form-item>
            <el-divider></el-divider>
          </el-form>
          <div align="center">
            <el-button type="danger" round class="login-button" @click="returnPage"
            >返回</el-button>
            <el-button type="primary" round class="login-button" @click="submitForm"
            >提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken} from "@/utils/auth";
import {getDicts} from "@/utils/data";
import { listPurchaseReport, getPurchaseReport, addPurchaseReport, updatePurchaseReport } from "@/api/purchase/purchaseReport";

export default {
  name: "reportAdd",
  components: {
  },
  data() {
    return {
      title: "赣州产控电子采购平台",
      active: 0,
      countTime: 0, // 倒计时
      timers: null,
      form: {
        userName: "",
        confirmUserName: "",
        fullName: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        phoneCode: "",
      },
      //初始值
      show: "false",
      count: "",
      loading: false,
      redirect: undefined,
      rules: {
      },
      rulesReport: {
        typeId: [
          { required: true, message: "类型不能为空", trigger: "blur" }
        ],
        askContent: [
          { required: true, message: "提问内容不能为空", trigger: "blur" }
        ],
      },
      formReport: {

      },
      // 公司性质字典
      companyTypeOptions: [],
      // 公司信息状态字典
      statusOptions: [],
      // 是否为一般纳税人字典
      generalTaxpayerOptions: [],
      // 是否三证合一字典
      threeCertificatesOptions: [],
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/api/purchase/file/upload",
        // 上传的文件列表
        fileList: [],
      },
      applyFileList: [],
      disabled: false,
      typeIdOptions: [],
    };
  },

  mounted() {},

  updated() {},

  computed: {},

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    getDicts("purchase_report_type").then(response => {
      this.typeIdOptions = response.data;
      this.formReport.typeId = this.$route.query.typeId;
    });
  },

  methods: {
    changeType() {
      this.$router.push("/login");
    },
    // 表单重置
    reset() {
      this.form = {
      };
    },
    // 文件超出个数限制时的钩子函数
    fileLimitCallback(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload(file) {
      const isLt200M = file.size / 1024 / 1024 < 200;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 200M!");
        return false;
      }
      return true;
    },
    handleFileChange(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.applyFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess(file, fileList) {
      this.applyFileList = fileList;
    },
    // 文件提交处理
    submitUpload() {
      this.$refs.fileUpload.submit();
    },
    // 文件预览
    handlePreview(file) {
      window.open(file.url);
    },

    /** 提交公司信息按钮 */
    submitForm() {
      this.$refs["formReport"].validate(valid => {
        if (valid) {
          this.formReport.inviteBidId = this.$route.query.inviteBidId;
          this.formReport.applyFileList = this.applyFileList;
          this.formReport.status = 1;
          this.formReport.publicStatus = 0;
          addPurchaseReport(this.formReport).then(response => {
            if (response.code == 200) {
              this.$message.success("提交成功");
              this.returnPage();
            }
          });
        }
      });
    },
    returnPage(){
      this.$router.push("/inviteBidView?id=" + this.$route.query.inviteBidId);
    },
    resetReport() {
      this.formReport = {
        typeId: null,
        askContent: null,
        applyFileList: []
      };
    },
  }, //methods end
};
</script>
<style lang="less" scoped>
.resumeSection{
  width: 1200px;
}
.resumeSection__form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 1202px;
}

.el-select .el-input__inner {
  width: 315px;
}

.inputWidth {
  width: 315px;
}

.el-upload {
  width: 35%;

  .uploadFile__works {
    .uploadWorks__fileicon {
      width: 50px;
      height: 50px;
      margin: auto;
    }

    .el-icon-warning {
      font-size: 30px;
    }
  }

  &:focus {
    border-color: inherit;
    color: inherit;
  }

  &-dragger {
    display: table-cell;
    vertical-align: middle;

    border: none;
    background: @bg-base-color;
    width: 600px;

    .upload-button {
      display: inline-block;
      width: 100px;
      margin: 10px 0;
    }

    .afterUpload {
      .fileicon {
        width: 50px;
        height: 50px;
        margin: auto;
      }

      time {
        color: @secondary-text-color;
      }

      &__actionButton {
        color: @main-color;

        &-dividerLine {
          margin: 0 14px;
        }
      }
    }
  }
}

.upload-success-tip {
  display: flex;
  background: @bg-base-color;
  padding: 0 7px;
  align-items: center;

  .el-icon-warning {
    color: @main-color;
  }

  .tips-resolve {
    color: @main-color;
    cursor: pointer;
    margin-left: 6px;
  }

  .el-icon-close {
    cursor: pointer;
    margin-left: auto;
  }
}

// }
.resumeSection {
  .el-select,
  .el-date-editor {
    width: 100%;
  }

  .bottom-action {
    display: flex;

    .el-icon-plus,
    .el-icon-delete {
      font-size: 22px;
      cursor: pointer;

      &-top {
        margin-left: auto;
      }
    }

    .el-icon-delete {
      margin-left: auto;
    }
  }

  .el-form {
    margin-bottom: 40px;

    &:not(:last-child) {
      border-bottom: 1px solid @border-light-color;
    }
  }
}
</style>

<style lang="less" scoped>
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}

.resume-editor-mobile {
  margin: auto;
  padding: 30px 0;
}

.resumeEditor-footerAction {
  padding: 30px 190px;
  z-index: 33;
  text-align: right;

  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}

.resumeSection {
  padding: 50px 10px;
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    //margin-right: 200px;
    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }

  &__form {
    display: flex;
    align-items: flex-start;
    //justify-content: space-between;
    margin-top: 20px;
    width: 600px;
  }
}
</style>
